import PageIntro from "@/components/site/PageIntro";
import Manifesto from "@/components/site/Manifesto";
import Testimonials from "@/components/site/Testimonials";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <PageIntro
        overline="About"
        title="The studio."
        subtitle="Since 2016 we've been the quiet force behind resilient systems and standout software for teams across healthcare, logistics, retail and manufacturing."
      />
      <Manifesto />
      <Testimonials />
    </div>
  );
}
